import React from 'react'

const TeamBioSection = (props) => {

  let content = props.content


  console.log(content);

  if(content===false){
    return  <div className='bio bio-closed' ></div>
  }else{

      return (
        <div className={(props.open)? 'bio bio-open' : 'bio bio-closed'} >
          <div className="team-bio-section" >

              <div className="close-button" onClick={props.closeHandler}>

              </div>
              <div className="photo" style={{backgroundImage:'url('+content.acf.photo.url+')'}}></div>
              <div className="copy-container">
                  <h2 dangerouslySetInnerHTML={{__html:content.title.rendered}}></h2>
                  <div className="title" dangerouslySetInnerHTML={{__html:content.acf.title}}></div>
                  <div className="text" dangerouslySetInnerHTML={{__html:content.acf.bio}}></div>

                  {(content.acf.imdb || content.acf.linkedin_link || content.acf.twitter)?
                    <div className="social-icons">
                        <h5>Social Links</h5>
                        {(content.acf.imdb)?
                          <a href={content.acf.imdb} className="imdb" target="_blank">{content.acf.imdb}</a>
                         : null
                        }

                        {(content.acf.linkedin_link)?
                          <a href={content.acf.linkedin_link} className="linkedin" target="_blank">{content.acf.linkedin_link}</a>
                        : null }

                        {(content.acf.twitter)?
                          <a href={content.acf.twitter} className="twitter" target="_blank">{content.acf.twitter}</a>
                        : null }
                    </div>
                    : null }



              </div>
          </div>
      </div>
      )
    }
  }

export default TeamBioSection



// WEBPACK FOOTER //
// ./src/modules/teampage/TeamBioSection.js